import React from 'react';
import { Form } from 'react-bootstrap';

const conversionFactors = {
    // Length conversions
    in_to_mm: 25.4,
    in_to_cm: 2.54,
    ft_to_m: 0.3048,

    // Pressure/Strength conversions
    psi_to_MPa: 0.00689476,
    psi_to_kPa: 6.89476,
    pci_to_kN_m3: 271.447,

    // Mass conversions
    lb_to_kg: 0.453592,
    ton_to_kg: 907.185
};

function PanelHMA({
    onDataChange,
    data,
    unitSystem,
    convertPressure,
    displayPressureUnit,
    convertLength,
    displayLengthUnit,
    handleBlur,
    getFieldState,
    fieldPrefix = ""
}) {

    // Helper function to convert feet to meters for length fields
    const convertLengthFt = (value) => {
        return unitSystem === 'imperial' ? value : value * conversionFactors.ft_to_m;
    };

    // Helper function to display length unit for ft fields
    const displayLengthUnitFt = () => {
        return unitSystem === 'imperial' ? 'ft' : 'm';
    };

    return (
        <div className="pd-table-responsive">
            <table>
                <thead>
                    <tr>
                        <th className="pd__label pd__table-head">Parameters</th>
                        <th className="pd__label pd__table-head">Min</th>
                        <th className="pd__label pd__table-head">Mean</th>
                        <th className="pd__label pd__table-head">Max</th>
                        <th className="pd__label pd__table-head">Distribution</th>
                    </tr>
                </thead>
            <tbody>
                {/* AC Binder Type: AC - NO CONVERSION NEEDED */}
                <tr>
                    <td className="pd__label">AC Binder Type: Viscosity Grade</td>
                    <td colSpan={3}>
                        <Form.Select
                            size="sm"
                            className="pd-select-xl"
                            name="hmaDesign.acBinderType.value"
                            value={data.hmaDesign.acBinderType.value}
                            onChange={onDataChange}>
                                <option value="2.5">AC 2.5</option>
                                <option value="5">AC 5</option>
                                <option value="10">AC 10</option>
                                <option value="20">AC 20</option>
                                <option value="30">AC 30</option>
                                <option value="40">AC 40</option>
                        </Form.Select>
                    </td>   
                    <td>
                        <Form.Select
                            size="sm"
                            className="pd-select-md"
                            name="hmaDesign.acBinderType.distribution"
                            value={data.hmaDesign.acBinderType.distribution}
                            onChange={onDataChange}>
                                <option value="Uniform" selected>Uniform</option>
                                <option value="Normal">Normal</option>
                                <option value="Lognormal">Lognormal</option>
                                <option value="Triangular">Triangular</option>
                        </Form.Select>
                    </td>
                </tr>

                {/* Effective Binder Content (%) - NO CONVERSION NEEDED */}
                <tr>
                    <td className="pd__label">Effective Binder Content (%)</td>
                    <td>
                        <Form.Control
                            type="number"
                            size="sm"
                            className="pd-input-sm"
                            name="hmaDesign.effectiveBinderContent.min"
                            value={parseFloat(parseFloat(data.hmaDesign.effectiveBinderContent.min).toFixed(2))}
                            onChange={onDataChange}
                            onBlur={() => handleBlur(`${fieldPrefix}hmaDesign.effectiveBinderContent.min`, data.hmaDesign.effectiveBinderContent.min, 'number')}
                            isInvalid={getFieldState(`${fieldPrefix}hmaDesign.effectiveBinderContent.min`).isInvalid}
                        />
                    </td>
                    <td>
                        <Form.Control
                            type="number"
                            size="sm"
                            className="pd-input-sm"
                            name="hmaDesign.effectiveBinderContent.mean"
                            value={parseFloat(parseFloat(data.hmaDesign.effectiveBinderContent.mean).toFixed(2))}
                            onChange={onDataChange}
                            onBlur={() => handleBlur(`${fieldPrefix}hmaDesign.effectiveBinderContent.mean`, data.hmaDesign.effectiveBinderContent.mean, 'number')}
                            isInvalid={getFieldState(`${fieldPrefix}hmaDesign.effectiveBinderContent.mean`).isInvalid}
                        />
                    </td>
                    <td>
                        <Form.Control
                            type="number"
                            size="sm"
                            className="pd-input-sm"
                            name="hmaDesign.effectiveBinderContent.max"
                            value={parseFloat(parseFloat(data.hmaDesign.effectiveBinderContent.max).toFixed(2))}
                            onChange={onDataChange}
                            onBlur={() => handleBlur(`${fieldPrefix}hmaDesign.effectiveBinderContent.max`, data.hmaDesign.effectiveBinderContent.max, 'number')}
                            isInvalid={getFieldState(`${fieldPrefix}hmaDesign.effectiveBinderContent.max`).isInvalid}
                        />
                    </td>
                    <td>
                        <Form.Select
                            size="sm"
                            className="pd-select-md"
                            name="hmaDesign.effectiveBinderContent.distribution"
                            value={data.hmaDesign.effectiveBinderContent.distribution}
                            onChange={onDataChange}
                            defaultValue={data.hmaDesign.effectiveBinderContent.distribution}>
                                <option value="Uniform" selected>Uniform</option>
                                <option value="Normal">Normal</option>
                                <option value="Lognormal">Lognormal</option>
                                <option value="Triangular">Triangular</option>
                        </Form.Select>
                    </td>
                </tr>

                {/* AC Air Voids - NO CONVERSION NEEDED */}
                <tr>
                    <td className="pd__label">AC Air Voids (%)</td>
                    <td>
                        <Form.Control
                            type="number"
                            size="sm"
                            className="pd-input-sm"
                            name="hmaDesign.airVoids.min"
                            value={parseFloat(parseFloat(data.hmaDesign.airVoids.min).toFixed(2))}
                            onChange={onDataChange}
                            onBlur={() => handleBlur(`${fieldPrefix}hmaDesign.airVoids.min`, data.hmaDesign.airVoids.min, 'number')}
                            isInvalid={getFieldState(`${fieldPrefix}hmaDesign.airVoids.min`).isInvalid}
                        />
                    </td>
                    <td>
                        <Form.Control
                            type="number"
                            size="sm"
                            className="pd-input-sm"
                            name="hmaDesign.airVoids.mean"
                            value={parseFloat(parseFloat(data.hmaDesign.airVoids.mean).toFixed(2))}
                            onChange={onDataChange}
                            onBlur={() => handleBlur(`${fieldPrefix}hmaDesign.airVoids.mean`, data.hmaDesign.airVoids.mean, 'number')}
                            isInvalid={getFieldState(`${fieldPrefix}hmaDesign.airVoids.mean`).isInvalid}
                        />
                    </td>
                    <td>
                        <Form.Control
                            type="number"
                            size="sm"
                            className="pd-input-sm"
                            name="hmaDesign.airVoids.max"
                            value={parseFloat(parseFloat(data.hmaDesign.airVoids.max).toFixed(2))}
                            onChange={onDataChange}
                            onBlur={() => handleBlur(`${fieldPrefix}hmaDesign.airVoids.max`, data.hmaDesign.airVoids.max, 'number')}
                            isInvalid={getFieldState(`${fieldPrefix}hmaDesign.airVoids.max`).isInvalid}
                        />
                    </td>
                    <td>
                        <Form.Select
                            size="sm"
                            className="pd-select-md"
                            name="hmaDesign.airVoids.distribution"
                            value={data.hmaDesign.airVoids.distribution}
                            onChange={onDataChange}>
                                <option value="Uniform" selected>Uniform</option>
                                <option value="Normal">Normal</option>
                                <option value="Lognormal">Lognormal</option>
                                <option value="Triangular">Triangular</option>
                        </Form.Select>
                    </td>
                </tr>

                {/* AC Elastic Modulus - NOW WITH UNIT CONVERSION */}
                <tr>
                    <td className="pd__label">AC Elastic Modulus ({displayPressureUnit()})</td>
                    <td>
                        <Form.Control
                            type="number"
                            size="sm"
                            className="pd-input-sm"
                            name="hmaDesign.acElasticModulus.min"
                            value={parseFloat(parseFloat(convertPressure(data.hmaDesign.acElasticModulus.min)).toFixed(2))}
                            onChange={e => onDataChange({
                                target: {
                                    name: "hmaDesign.acElasticModulus.min",
                                    value: unitSystem === 'imperial'
                                        ? e.target.value
                                        : e.target.value / conversionFactors.psi_to_MPa
                                }
                            })}
                            onBlur={() => handleBlur(`${fieldPrefix}hmaDesign.acElasticModulus.min`, data.hmaDesign.acElasticModulus.min, 'number')}
                            isInvalid={getFieldState(`${fieldPrefix}hmaDesign.acElasticModulus.min`).isInvalid}
                        />
                    </td>
                    <td>
                        <Form.Control
                            type="number"
                            size="sm"
                            className="pd-input-sm"
                            name="hmaDesign.acElasticModulus.mean"
                            value={parseFloat(parseFloat(convertPressure(data.hmaDesign.acElasticModulus.mean)).toFixed(2))}
                            onChange={e => onDataChange({
                                target: {
                                    name: "hmaDesign.acElasticModulus.mean",
                                    value: unitSystem === 'imperial'
                                        ? e.target.value
                                        : e.target.value / conversionFactors.psi_to_MPa
                                }
                            })}
                            onBlur={() => handleBlur(`${fieldPrefix}hmaDesign.acElasticModulus.mean`, data.hmaDesign.acElasticModulus.mean, 'number')}
                            isInvalid={getFieldState(`${fieldPrefix}hmaDesign.acElasticModulus.mean`).isInvalid}
                        />
                    </td>
                    <td>
                        <Form.Control
                            type="number"
                            size="sm"
                            className="pd-input-sm"
                            name="hmaDesign.acElasticModulus.max"
                            value={parseFloat(parseFloat(convertPressure(data.hmaDesign.acElasticModulus.max)).toFixed(2))}
                            onChange={e => onDataChange({
                                target: {
                                    name: "hmaDesign.acElasticModulus.max",
                                    value: unitSystem === 'imperial'
                                        ? e.target.value
                                        : e.target.value / conversionFactors.psi_to_MPa
                                }
                            })}
                            onBlur={() => handleBlur(`${fieldPrefix}hmaDesign.acElasticModulus.max`, data.hmaDesign.acElasticModulus.max, 'number')}
                            isInvalid={getFieldState(`${fieldPrefix}hmaDesign.acElasticModulus.max`).isInvalid}
                        />
                    </td>
                    <td>
                        <Form.Select
                            size="sm"
                            className="pd-select-md"
                            name="hmaDesign.acElasticModulus.distribution"
                            value={data.hmaDesign.acElasticModulus.distribution}
                            onChange={onDataChange}>
                                <option value="Uniform" selected>Uniform</option>
                                <option value="Normal">Normal</option>
                                <option value="Lognormal">Lognormal</option>
                                <option value="Triangular">Triangular</option>
                        </Form.Select>
                    </td>
                </tr>

                {/* Base Resilient Modulus (ESB) - NOW WITH UNIT CONVERSION */}
                <tr>
                    <td className="pd__label">Base Resilient Modulus (ESB): {displayPressureUnit()}</td>
                    <td>
                        <Form.Control
                            type="number"
                            size="sm"
                            className="pd-input-sm"
                            name="hmaDesign.baseResilientModulus.min"
                            value={parseFloat(parseFloat(convertPressure(data.hmaDesign.baseResilientModulus.min)).toFixed(2))}
                            onChange={e => onDataChange({
                                target: {
                                    name: "hmaDesign.baseResilientModulus.min",
                                    value: unitSystem === 'imperial'
                                        ? e.target.value
                                        : e.target.value / conversionFactors.psi_to_MPa
                                }
                            })}
                            onBlur={() => handleBlur(`${fieldPrefix}hmaDesign.baseResilientModulus.min`, data.hmaDesign.baseResilientModulus.min, 'number')}
                            isInvalid={getFieldState(`${fieldPrefix}hmaDesign.baseResilientModulus.min`).isInvalid}
                        />
                    </td>
                    <td>
                        <Form.Control
                            type="number"
                            size="sm"
                            className="pd-input-sm"
                            name="hmaDesign.baseResilientModulus.mean"
                            value={parseFloat(parseFloat(convertPressure(data.hmaDesign.baseResilientModulus.mean)).toFixed(2))}
                            onChange={e => onDataChange({
                                target: {
                                    name: "hmaDesign.baseResilientModulus.mean",
                                    value: unitSystem === 'imperial'
                                        ? e.target.value
                                        : e.target.value / conversionFactors.psi_to_MPa
                                }
                            })}
                            onBlur={() => handleBlur(`${fieldPrefix}hmaDesign.baseResilientModulus.mean`, data.hmaDesign.baseResilientModulus.mean, 'number')}
                            isInvalid={getFieldState(`${fieldPrefix}hmaDesign.baseResilientModulus.mean`).isInvalid}
                        />
                    </td>
                    <td>
                        <Form.Control
                            type="number"
                            size="sm"
                            className="pd-input-sm"
                            name="hmaDesign.baseResilientModulus.max"
                            value={parseFloat(parseFloat(convertPressure(data.hmaDesign.baseResilientModulus.max)).toFixed(2))}
                            onChange={e => onDataChange({
                                target: {
                                    name: "hmaDesign.baseResilientModulus.max",
                                    value: unitSystem === 'imperial'
                                        ? e.target.value
                                        : e.target.value / conversionFactors.psi_to_MPa
                                }
                            })}
                            onBlur={() => handleBlur(`${fieldPrefix}hmaDesign.baseResilientModulus.max`, data.hmaDesign.baseResilientModulus.max, 'number')}
                            isInvalid={getFieldState(`${fieldPrefix}hmaDesign.baseResilientModulus.max`).isInvalid}
                        />
                    </td>
                    <td>
                        <Form.Select
                            size="sm"
                            className="pd-select-md"
                            name="hmaDesign.baseResilientModulus.distribution"
                            value={data.hmaDesign.baseResilientModulus.distribution}
                            onChange={onDataChange}>
                                <option value="Uniform" selected>Uniform</option>
                                <option value="Normal">Normal</option>
                                <option value="Lognormal">Lognormal</option>
                                <option value="Triangular">Triangular</option>
                        </Form.Select>
                    </td>
                </tr>

                {/* Subgrade Resilient Modulus (MR) - NOW WITH UNIT CONVERSION */}
                <tr>
                    <td className="pd__label">Subgrade Resilient Modulus (MR): {displayPressureUnit()}</td>
                    <td>
                        <Form.Control
                            type="number"
                            size="sm"
                            className="pd-input-sm"
                            name="hmaDesign.subgradeResilientModulus.min"
                            value={parseFloat(parseFloat(convertPressure(data.hmaDesign.subgradeResilientModulus.min)).toFixed(2))}
                            onChange={e => onDataChange({
                                target: {
                                    name: "hmaDesign.subgradeResilientModulus.min",
                                    value: unitSystem === 'imperial'
                                        ? e.target.value
                                        : e.target.value / conversionFactors.psi_to_MPa
                                }
                            })}
                            onBlur={() => handleBlur(`${fieldPrefix}hmaDesign.subgradeResilientModulus.min`, data.hmaDesign.subgradeResilientModulus.min, 'number')}
                            isInvalid={getFieldState(`${fieldPrefix}hmaDesign.subgradeResilientModulus.min`).isInvalid}
                        />
                    </td>
                    <td>
                        <Form.Control
                            type="number"
                            size="sm"
                            className="pd-input-sm"
                            name="hmaDesign.subgradeResilientModulus.mean"
                            value={parseFloat(parseFloat(convertPressure(data.hmaDesign.subgradeResilientModulus.mean)).toFixed(2))}
                            onChange={e => onDataChange({
                                target: {
                                    name: "hmaDesign.subgradeResilientModulus.mean",
                                    value: unitSystem === 'imperial'
                                        ? e.target.value
                                        : e.target.value / conversionFactors.psi_to_MPa
                                }
                            })}
                            onBlur={() => handleBlur(`${fieldPrefix}hmaDesign.subgradeResilientModulus.mean`, data.hmaDesign.subgradeResilientModulus.mean, 'number')}
                            isInvalid={getFieldState(`${fieldPrefix}hmaDesign.subgradeResilientModulus.mean`).isInvalid}
                        />
                    </td>
                    <td>
                        <Form.Control
                            type="number"
                            size="sm"
                            className="pd-input-sm"
                            name="hmaDesign.subgradeResilientModulus.max"
                            value={parseFloat(parseFloat(convertPressure(data.hmaDesign.subgradeResilientModulus.max)).toFixed(2))}
                            onChange={e => onDataChange({
                                target: {
                                    name: "hmaDesign.subgradeResilientModulus.max",
                                    value: unitSystem === 'imperial'
                                        ? e.target.value
                                        : e.target.value / conversionFactors.psi_to_MPa
                                }
                            })}
                            onBlur={() => handleBlur(`${fieldPrefix}hmaDesign.subgradeResilientModulus.max`, data.hmaDesign.subgradeResilientModulus.max, 'number')}
                            isInvalid={getFieldState(`${fieldPrefix}hmaDesign.subgradeResilientModulus.max`).isInvalid}
                        />
                    </td>
                    <td>
                        <Form.Select
                            size="sm"
                            className="pd-select-md"
                            name="hmaDesign.subgradeResilientModulus.distribution"
                            value={data.hmaDesign.subgradeResilientModulus.distribution}
                            onChange={onDataChange}>
                                <option value="Uniform" selected>Uniform</option>
                                <option value="Normal">Normal</option>
                                <option value="Lognormal">Lognormal</option>
                                <option value="Triangular">Triangular</option>
                        </Form.Select>
                    </td>
                </tr>

                {/* Depth to Rigid Foundation - NOW WITH UNIT CONVERSION */}
                <tr>
                    <td className="pd__label">Depth to Rigid Foundation ({displayLengthUnitFt()})</td>
                    <td>
                        <Form.Control
                            type="number"
                            size="sm"
                            className="pd-input-sm"
                            name="hmaDesign.depthToRigidFoundation.min"
                            value={parseFloat(parseFloat(convertLengthFt(data.hmaDesign.depthToRigidFoundation.min)).toFixed(2))}
                            onChange={e => onDataChange({
                                target: {
                                    name: "hmaDesign.depthToRigidFoundation.min",
                                    value: unitSystem === 'imperial'
                                        ? e.target.value
                                        : e.target.value / conversionFactors.ft_to_m
                                }
                            })}
                            onBlur={() => handleBlur(`${fieldPrefix}hmaDesign.depthToRigidFoundation.min`, data.hmaDesign.depthToRigidFoundation.min, 'number')}
                            isInvalid={getFieldState(`${fieldPrefix}hmaDesign.depthToRigidFoundation.min`).isInvalid}
                        />
                    </td>
                    <td>
                        <Form.Control
                            type="number"
                            size="sm"
                            className="pd-input-sm"
                            name="hmaDesign.depthToRigidFoundation.mean"
                            value={parseFloat(parseFloat(convertLengthFt(data.hmaDesign.depthToRigidFoundation.mean)).toFixed(2))}
                            onChange={e => onDataChange({
                                target: {
                                    name: "hmaDesign.depthToRigidFoundation.mean",
                                    value: unitSystem === 'imperial'
                                        ? e.target.value
                                        : e.target.value / conversionFactors.ft_to_m
                                }
                            })}
                            onBlur={() => handleBlur(`${fieldPrefix}hmaDesign.depthToRigidFoundation.mean`, data.hmaDesign.depthToRigidFoundation.mean, 'number')}
                            isInvalid={getFieldState(`${fieldPrefix}hmaDesign.depthToRigidFoundation.mean`).isInvalid}
                        />
                    </td>
                    <td>
                        <Form.Control
                            type="number"
                            size="sm"
                            className="pd-input-sm"
                            name="hmaDesign.depthToRigidFoundation.max"
                            value={parseFloat(parseFloat(convertLengthFt(data.hmaDesign.depthToRigidFoundation.max)).toFixed(2))}
                            onChange={e => onDataChange({
                                target: {
                                    name: "hmaDesign.depthToRigidFoundation.max",
                                    value: unitSystem === 'imperial'
                                        ? e.target.value
                                        : e.target.value / conversionFactors.ft_to_m
                                }
                            })}
                            onBlur={() => handleBlur(`${fieldPrefix}hmaDesign.depthToRigidFoundation.max`, data.hmaDesign.depthToRigidFoundation.max, 'number')}
                            isInvalid={getFieldState(`${fieldPrefix}hmaDesign.depthToRigidFoundation.max`).isInvalid}
                        />
                    </td>
                    <td>
                        <Form.Select
                            size="sm"
                            className="pd-select-md"
                            name="hmaDesign.depthToRigidFoundation.distribution"
                            value={data.hmaDesign.depthToRigidFoundation.distribution}
                            onChange={onDataChange}>
                                <option value="Uniform" selected>Uniform</option>
                                <option value="Normal">Normal</option>
                                <option value="Lognormal">Lognormal</option>
                                <option value="Triangular">Triangular</option>
                        </Form.Select>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    );
}

export default PanelHMA;